import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-db3e7e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-emploi-du-temps-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Type d'emploi du temps "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date début "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = ["min"]
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date fin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "text-muted d-block mt-1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-12" }
const _hoisted_26 = { class: "border border-primary rounded-3 mt-4 mb-3" }
const _hoisted_27 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary rounded-0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-5 text-white" }, "Ajouter des cours")
], -1))
const _hoisted_29 = { class: "col-md-5" }
const _hoisted_30 = { class: "d-flex justify-content-end" }
const _hoisted_31 = ["disabled", "title"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-2 fs-6" }, null, -1))
const _hoisted_33 = { class: "marge-droite" }
const _hoisted_34 = { class: "row mt-10" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "badge bg-primary text-white fs-6 mb-10" }
const _hoisted_37 = { class: "row mt-10" }
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Jour "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Heure de début "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_42 = ["onChange"]
const _hoisted_43 = { class: "col-md-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Heure de fin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_45 = ["onChange"]
const _hoisted_46 = { class: "col-md-5" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_48 = { class: "row mt-10" }
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Professeur "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Classe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_53 = { class: "col-md-2 d-flex align-items-center mt-30" }
const _hoisted_54 = { class: "form-check" }
const _hoisted_55 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_56 = ["for"]
const _hoisted_57 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Lien Visioconférence "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_59 = ["onInput"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_62 = { class: "col-md-12" }
const _hoisted_63 = {
  class: "alert alert-danger d-flex align-items-start mb-0",
  role: "alert"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle me-2 mt-1" }, null, -1))
const _hoisted_65 = { class: "flex-grow-1" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Classe occupée :", -1))
const _hoisted_68 = { key: 1 }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Professeur occupé :", -1))
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Conflit détecté :", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1))
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-12" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "emploiDuTempsForm",
        onSubmit: _ctx.addEmploiDuTemps,
        onInvalidSubmit: _ctx.handleInvalidSubmit,
        "validation-schema": _ctx.emploiDuTempsSchema,
        validateOnInput: false,
        validateOnMount: false,
        initialValues: {
          typeEmploi: '',
          dateDebut: _ctx.getCurrentDate(),
          dateFin: _ctx.getCurrentDate(),
          niveau: '',
          filiere: '',
          coursAdded: []
        }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, { name: "typeEmploi" }, {
                  default: _withCtx(({ field, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.typeEmploiOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": (val) => { handleChange(val); _ctx.onTypeEmploiChange(val); },
                      placeholder: "Sélectionner le type"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "typeEmploi",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, { name: "dateDebut" }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "date",
                      min: _ctx.getCurrentDate(),
                      class: "form-control shadow-none fs-md-15 text-black",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDateDebutChange && _ctx.onDateDebutChange(...args)))
                    }), null, 16, _hoisted_10)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDebut",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Field, { name: "dateFin" }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", {
                      value: field.value,
                      type: "date",
                      class: "form-control shadow-none fs-md-15 text-black bg-light",
                      readonly: "",
                      style: {"pointer-events":"none"}
                    }, null, 8, _hoisted_14),
                    _createElementVNode("input", _mergeProps(field, { type: "hidden" }), null, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "dateFin",
                  class: "text-danger"
                }),
                (_ctx.dateDebut && _ctx.dateFin && _ctx.selectedTypeEmploiLibelle)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(" Période de " + _toDisplayString(_ctx.getDiffJours(_ctx.dateDebut, _ctx.dateFin)) + " jours (" + _toDisplayString(_ctx.selectedTypeEmploiLibelle) + ") ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_Field, { name: "niveau" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.globalNiveauxOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onGlobalNiveauChange,
                      placeholder: "Sélectionner le niveau"
                    }), null, 16, ["options", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "niveau",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_Field, { name: "filiere" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.globalFilieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onGlobalFiliereChange,
                      placeholder: "Sélectionner la filière",
                      disabled: !_ctx.globalSelectedNiveau || _ctx.isLoadingFilieres
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "filiere",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        class: "btn btn-success fw-semibold shadow-sm text-nowrap",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewCours && _ctx.addNewCours(...args))),
                        disabled: !_ctx.isLastCoursComplete,
                        title: !_ctx.isLastCoursComplete
                        ? 'Veuillez remplir tous les champs obligatoires du cours actuel'
                        : 'Ajouter un nouveau cours'
                      }, [
                        _hoisted_32,
                        _createTextVNode(" Ajouter un cours ")
                      ], 8, _hoisted_31)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedCours, (cours, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cours.tempId
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("h5", _hoisted_36, " Cours " + _toDisplayString(index + 1), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].jour`
                          }, {
                            default: _withCtx(({ value, handleChange }) => [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.joursOptions,
                                searchable: true,
                                "track-by": "value",
                                label: "label",
                                modelValue: value,
                                "onUpdate:modelValue": (val) => {
                            handleChange(val);
                            _ctx.onJourChange(index, val);
                            if (_ctx.addedCours[index]) {
                              _ctx.addedCours[index].jour = val?.value || val;
                            }
                            _ctx.checkCoursAvailability(index);
                          },
                                placeholder: "Sélectionner un jour"
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].jour`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].heureDebut`,
                            type: "time",
                            class: "form-control shadow-none text-black"
                          }, {
                            default: _withCtx(({ field }) => [
                              _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                type: "time",
                                class: "form-control shadow-none text-black",
                                onChange: (event) => _ctx.onHeureChange(index, 'debut', event)
                              }), null, 16, _hoisted_42)
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].heureDebut`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].heureFin`,
                            type: "time",
                            class: "form-control shadow-none text-black"
                          }, {
                            default: _withCtx(({ field }) => [
                              _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                type: "time",
                                class: "form-control shadow-none text-black",
                                onChange: (event) => _ctx.onHeureChange(index, 'fin', event)
                              }), null, 16, _hoisted_45)
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].heureFin`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].filiereNiveauMatiere`
                          }, {
                            default: _withCtx(({ field, value }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.globalMatieresOptions,
                                searchable: true,
                                "track-by": "value",
                                label: "label",
                                ref_for: true
                              }, field, {
                                value: value,
                                onChange: (matiereValue) => _ctx.onMatiereChange(index, matiereValue),
                                onInput: (matiereValue) => { 
                            if (_ctx.addedCours[index]) {
                              _ctx.addedCours[index].filiereNiveauMatiere = matiereValue?.value || matiereValue || null;
                            }
                          },
                                placeholder: "Sélectionner la matière",
                                disabled: !_ctx.globalSelectedNiveau || !_ctx.globalSelectedFiliere || _ctx.isLoadingMatieres
                              }), null, 16, ["options", "value", "onChange", "onInput", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].filiereNiveauMatiere`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].professeur`
                          }, {
                            default: _withCtx(({ value, handleChange }) => [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.getProfesseursByMatiere(cours.matiereId),
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: value,
                                "onUpdate:modelValue": (val) => {
                          handleChange(val);
                          if (_ctx.addedCours[index]) {
                            _ctx.addedCours[index].professeur = val?.value || val || null;
                          }
                          _ctx.checkCoursAvailability(index);
                        },
                                placeholder: "Sélectionner le professeur",
                                disabled: !cours.matiereId || !_ctx.getProfesseursByMatiere(cours.matiereId).length
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].professeur`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].classe`
                          }, {
                            default: _withCtx(({ value, handleChange }) => [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.classesOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: value,
                                "onUpdate:modelValue": (val) => {
                          handleChange(val);
                          _ctx.onClasseChange(index, val);
                          if (_ctx.addedCours[index]) {
                            _ctx.addedCours[index].classe = val?.value || val || null;
                          }
                          _ctx.checkCoursAvailability(index);
                        },
                                placeholder: "Sélectionner la classe"
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].classe`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              id: `enligne-${index}`,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.addedCours[index].estEnLigne) = $event),
                              onChange: ($event: any) => (_ctx.handleCheckboxChange(index, $event))
                            }, null, 40, _hoisted_55), [
                              [_vModelCheckbox, _ctx.addedCours[index].estEnLigne]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label fw-semibold",
                              for: `enligne-${index}`
                            }, " En ligne ", 8, _hoisted_56)
                          ])
                        ]),
                        (_ctx.addedCours[index].estEnLigne)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _hoisted_58,
                              _createVNode(_component_Field, {
                                name: `coursAdded[${index}].lienVisio`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "url",
                                    class: "form-control shadow-none text-black",
                                    placeholder: "https://meet.google.com/xxx-xxxx-xxx",
                                    onInput: ($event: any) => (_ctx.onVisioInput($event, index))
                                  }), null, 16, _hoisted_59)
                                ]),
                                _: 2
                              }, 1032, ["name"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `coursAdded[${index}].lienVisio`,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-md-2 d-flex align-items-start", { 'mt-30': !_ctx.addedCours[index].estEnLigne }])
                        }, [
                          (_ctx.addedCours.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-danger transition border-0 ps-8 pe-8",
                                type: "button",
                                onClick: ($event: any) => (_ctx.removeCours(index))
                              }, " Supprimer ", 8, _hoisted_60))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      (_ctx.coursDisponibilite[cours.tempId] && !_ctx.coursDisponibilite[cours.tempId].available)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("div", _hoisted_65, [
                                  (_ctx.coursDisponibilite[cours.tempId].conflictingCours?.conflictType === 'classe')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        _hoisted_67,
                                        _createTextVNode(" La classe "),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.getClasseLabel(cours.classe || null)), 1),
                                        _createTextVNode(" est déjà occupée le "),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.jour), 1),
                                        _createTextVNode(" de "),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.heureDebut), 1),
                                        _createTextVNode(" à "),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.heureFin), 1)
                                      ]))
                                    : (_ctx.coursDisponibilite[cours.tempId].professeurOccupe || _ctx.coursDisponibilite[cours.tempId].conflictingCours?.conflictType === 'professeur')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                          _hoisted_69,
                                          (_ctx.coursDisponibilite[cours.tempId].conflictingCours?.details?.professeur)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.professeur), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" est déjà occupé(e) le "),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.jour), 1),
                                          _createTextVNode(" de "),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.heureDebut), 1),
                                          _createTextVNode(" à "),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.heureFin), 1),
                                          (_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.classe)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                                _createTextVNode(" avec la classe "),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.coursDisponibilite[cours.tempId].conflictingCours.details.classe), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                          _hoisted_73,
                                          _createTextVNode(" Ce créneau horaire n'est pas disponible ")
                                        ]))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _hoisted_74
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting || _ctx.hasAvailabilityConflicts
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_79))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Création' : 'Ajouter l\'emploi du temps'), 1)
                ], 8, _hoisted_78),
                _createVNode(_component_router_link, {
                  to: "/liste-emplois",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_80,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema", "initialValues"])
    ])
  ]))
}